import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemId'}/update`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemId/update`;

export const URL = (itemId: number): RouteDefinition => `${baseRoute}/${itemId}/update`;
